import React, { useState } from 'react';
import styles from '../products.module.scss';
import cx from 'classname';
import Input from 'components/input';
import ImageUpload from 'components/image-upload';
import TextArea from 'components/new-textarea';
import PhonePreview from '../Preview';
import { ListIcon, PreviewImageDefault } from 'components/icons';
import { globalStyles } from 'styles';
import classname from 'classname';
import { useForm } from 'react-hook-form';
import CustomSelect from 'components/common/CustomSelect';
import Button from 'components/button';
import { useDispatch } from 'react-redux';
import { showToast } from 'store/actions/toast';

const StepOne = ({ changeStep, sectors, handleChange, data, setData }) => {
  const [error, setError] = useState(false);
  const [cat, setCat] = useState('');
  const dispatch = useDispatch();

  const { handleSubmit, errors, register, clearErrors } = useForm({
    defaultValues: {},
  });

  const onContinue = () => {
    changeStep(2);
    setData({
      ...data,
      features: !Array.isArray(data?.features)
        ? data?.features.split(/\r?\n/).map((res) => res)
        : data.features,
    });
  };

  return (
    <div className={styles.chooseBody}>
      <div
        className={classname(
          globalStyles.flex1,
          styles.magCreate,
          globalStyles.flex,
          globalStyles.justifyContentBetween,
        )}
      >
        <div>
          <p className={styles.chooseTitle}>Edit Product</p>
          <p className={styles.chooseSub}>
            We want to know everything about your product
          </p>
        </div>
        <div>
          {/* <Button
            text="Save as Draft"
            variant="gray"
            className={styles.draftsBtn}
          /> */}

          <Button
            text=" Continue"
            variant="primary"
            className={styles.createBtn2}
            onClick={handleSubmit(onContinue)}
            type="submit"
            data-testid="continue"
          />
        </div>
      </div>

      <hr className={styles.line} />

      <div className={styles.rowCreate}>
        <div
          className={cx(
            styles.columnCreate,
            styles.leftCreate,
            styles.leftBg,
            styles.scrollStep,
          )}
        >
          <div className={styles.overviewFormGroupItem}>
            <ImageUpload
              label="Upload product logo"
              text="Click to upload product Icon or image"
              name="productLogo"
              value={data?.productImageUrl}
              type="box"
              onUpload={(value) => setData({ ...data, productImageUrl: value })}
              onError={() => {
                dispatch(
                  showToast('error', 'Error uploading image', 'Try again'),
                );
                setError(true);
              }}
              error={errors.productImageUrl}
            />
          </div>

          <div
            className={cx(
              globalStyles.flex,
              globalStyles.justifyContentBetween,
            )}
          >
            <div className={cx(globalStyles.w100, globalStyles.mr24)}>
              <Input
                label="Product Title"
                type="text"
                placeholder="Enter title here"
                autoFocus
                name="title"
                value={data?.title}
                onChange={handleChange}
                ref={register({
                  required: 'Product title required',
                })}
                error={errors['title']?.message}
                data-testid="title"
              />
            </div>

            <div className={cx(globalStyles.w100)}>
              <CustomSelect
                label="Product Category"
                name="businessSectorId"
                options={
                  sectors
                    ? sectors.map((data) => {
                        return {
                          text: data.name,
                          value: data.id,
                        };
                      })
                    : []
                }
                handleClick={(value) => {
                  setData({ ...data, businessSectorId: value.value });
                  setCat(value.text);
                }}
                error={errors.businessSectorId?.message}
                clearErrors={clearErrors}
                selectProps={{
                  ref: register({
                    required: 'Product category is required',
                  }),
                }}
                defaultValue={data?.businessSectorId}
              />
            </div>
          </div>

          <TextArea
            label="Description"
            placeholder="Enter product description"
            autoFocus
            rows="5"
            maxLength="280"
            name="description"
            value={data?.description}
            onChange={handleChange}
            ref={register({
              required: 'Product description required',
            })}
            error={errors['description']?.message}
            testId="description"
          />

          <TextArea
            label="Product Features"
            placeholder="Each benefit should be a new line"
            autoFocus
            rows="2"
            name="features"
            maxLength="280"
            value={
              Array.isArray(data?.features)
                ? data?.features.join('\n')
                : data?.features
            }
            onChange={handleChange}
            testId="features"
          />
        </div>
        <div
          className={cx(styles.columnCreate, styles.rightCreate, styles.pad)}
        >
          <p className={styles.description}>
            Here is a preview of the product you are creating
          </p>

          <PhonePreview title={data?.title}>
            <div className={styles.preview1}>
              <div
                className={classname(
                  styles.verticalgroup,
                  globalStyles.pb0,
                  globalStyles.pt0,
                )}
              >
                {data?.productImageUrl ? (
                  <img
                    src={data?.productImageUrl}
                    className={styles.preview1image}
                    width="30"
                    height="30"
                  />
                ) : (
                  <PreviewImageDefault style={{ margin: '10px 0' }} />
                )}
                <h3 className={styles.previewtitle}>{data?.title}</h3>
                <p className={styles.previewcategory}>{cat}</p>
                <p className={styles.previewdescription}>{data?.description}</p>
              </div>
              <div className={styles.verticalgroup}>
                <h3 className={styles.previewtitle}>Features</h3>
                {data?.features && (
                  <>
                    {!Array.isArray(data?.features)
                      ? data?.features.split(/\r?\n/).map((res, i) => {
                          return (
                            <p key={i} className={styles.previewdescription}>
                              <ListIcon />
                              {res}
                            </p>
                          );
                        })
                      : data?.features.map((res, i) => {
                          return (
                            <p key={i} className={styles.previewdescription}>
                              <ListIcon />
                              {res}
                            </p>
                          );
                        })}
                  </>
                )}
              </div>
            </div>
          </PhonePreview>
        </div>
      </div>
    </div>
  );
};

export default StepOne;
